import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ManagerRoute({ children }) {
  const { isAuthenticated, role } = useContext(AuthContext);

  if (!isAuthenticated()) return <Navigate to="/login" replace />;

  // ✅ STRICT: Only manager allowed
  if (role !== "manager") return <Navigate to="/" replace />;

  return children;
}
